<template>
  <el-row>	
		<div v-if="isApp" class="app-el-form app-form-box">
			<el-form
			  :rules="rules"
			  ref="ruleForm"
			  label-position="left"
			  label-width="0px"
			  :model="forData"
			>
				<el-form-item prop="name">
				  <el-input
				    @blur="validChange(1, $event)"
				    placeholder="请输入组织名称"
				    v-model="forData.name"
				  ></el-input>
				</el-form-item>
				<el-form-item prop="company_code">
				  <el-input
				    @blur="validChange(2, $event)"
				    placeholder="请输入社会统一信用代码"
				    v-model="forData.company_code"
				  ></el-input>
				</el-form-item>
				<el-form-item prop="legal_name">
				  <el-input
				    placeholder="请输入法人姓名"
				    v-model="forData.legal_name"
				  ></el-input>
				</el-form-item>
				<div :class="['wramings', showWarimg ? '' : 'hiddens']" :span="24">
				  <div>
				    <i class="el-icon-warning"></i>
				  </div>
				  <div>
				    该企业已经在翡云入驻，请联络该企业创建人，若企业被冒用请拨打客服电话。
				  </div>
				</div>
				<div class="btn-margin">
					<el-button
					  :disabled="!forData.is_read_agree || showWarimg"
					  @click="submit"
					  type="danger"
						style="width:100%;"
					  >注册新企业</el-button
					>
				</div>
				<el-form-item class="agree-box">
				  <div class="agree-box">
				    <div class="check-box">
				      <el-checkbox v-model="forData.is_read_agree" class="">
				      </el-checkbox>
				    </div>
				    <p style="color:#666666;" class="agree-info">
				      我已阅读并同意<span v-for="(item,index) in agreeList" :key="index">
				        <span class="agree" @click="agreeBtn(item)">《{{item.title}}》</span><template v-if="index<agreeList.length-1">和</template>
				      </span>
				    </p>
				  </div>
				</el-form-item>
			</el-form>
		</div>
    <el-form v-else
      :rules="rules"
      ref="ruleForm"
      label-position="left"
      label-width="0px"
      :model="forData"
    >
      <el-col :span="24">
        <el-form-item prop="name">
          <el-input
            @blur="validChange(1, $event)"
            placeholder="请输入组织名称"
            v-model="forData.name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item prop="company_code">
          <el-input
            @blur="validChange(2, $event)"
            placeholder="请输入社会统一信用代码"
            v-model="forData.company_code"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item prop="legal_name">
          <el-input
            placeholder="请输入法人姓名"
            v-model="forData.legal_name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :class="['wramings', showWarimg ? '' : 'hiddens']" :span="24">
        <div>
          <i class="el-icon-warning"></i>
        </div>
        <div>
          该企业已经在翡云入驻，请联络该企业创建人，若企业被冒用请拨打客服电话。
        </div>
      </el-col>

      <el-col :span="24" class="login-info">
        <el-button
          :disabled="!forData.is_read_agree || showWarimg"
          @click="submit"
          style="width: 100%;font-size: 18px;"
          type="danger"
          >注册新企业</el-button
        >
      </el-col>
      <el-col :span="24" v-if="agreeList&&agreeList.length>0">
        <el-form-item class="agree-box">
          <div class="agree-box">
            <div class="check-box">
              <el-checkbox v-model="forData.is_read_agree" class="">
              </el-checkbox>
            </div>
            <p style="color:#666666;" class="agree-info">
              我已阅读并同意<span v-for="(item,index) in agreeList" :key="index">
                <span class="agree" @click="agreeBtn(item)">《{{item.title}}》</span><template v-if="index<agreeList.length-1">和</template>
              </span>
            </p>
          </div>
        </el-form-item>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
import { postJSON } from "@/server/ajax.js";
import { parseTime } from '@/utils/validate.js';
import { isMobile } from "@/utils/wxConfig.js";
const URL = {
  VALID: "/base/company/isexist", // 验证企业是否入驻
  REGISTER: "/api/users/company_station/register", // 提交注册
};
export default {
  props: ["keys",'params'],
  data() {
    return {
			isApp:false,
      showWarimg: false,
      forData: {
        name: "",
        company_code: "",
        legal_name: "",
        first_key: "",
        is_read_agree: true,
        company_type:0,
      },
      message: {
        company_name: "",
        name: "",
        phone: "",
        times: "",
      },
      agreeList:[],
      rules: {
        company_name: [
          { required: true, message: "请输入组织名称", trigger: "blur" },
        ],
        company_code: [
          {
            required: true,
            trigger: "blur",
            validator:(rules,value,call)=>{
            	if(value){
            		// if(!/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)){
								if (!/^[0-9A-Z]{18}$/g.test(value)) {
            			call(new Error("请输入正确的社会统一信用代码"))
            		}else{
            			call();
            		}
            	}else{
            		call(new Error('请输入社会统一信用代码'))
            	}
            }
          },
        ],
        legal_name: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.message.name = this.keys.real_name;
    this.message.phone = this.keys.mobile;
		this.isApp = isMobile();
    this.message.times = parseTime(new Date(),'{y}-{m}-{d}');
    this.getAgreeList();
    if(this.params && this.params.id){
      this._initParams();
    }
  },
  watch:{
    "params.id"(){
      this._initParams();
    }
  },
  methods: {
    _initParams(){
      let data = this.params;
      this.forData.company_code = data.invite_code;
      this.forData.name = data.invite_name;
    },
    // 立即注册
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$emit('isok',this.forData);
        } else {
          this.$message({
            message: "请填写完整的信息",
            type: "warning",
          });
        }
      });
    },
    agreeBtn(row){
      let routeUrl = this.$router.resolve({
        path:'/register/agreement',
        query:{
          id:row.id,
        }
      })
      window.open(routeUrl.href, '_blank');
    },
    getAgreeList(){ //入驻协议
      this.$axios.get('/setting/agreement/station_list').then(res=>{
        if(res.code==200){
          let data = res.data;
          if(data && data.length>0){
            this.agreeList = res.data;
          }else{
            this.fromData.is_read_agree = true;
          }
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    validChange(val, event) {
      let params = {},nume = event.target.value;
      if (val == 1) {
        params.name = nume;
        this.message.company_name = nume;
      } else {
        params.company_code = nume;
      }
      postJSON(URL.VALID, params).then(
        (res) => {
          if(res.data){
            this.showWarimg = true;
          }else{
            this.showWarimg = false;
          }
        },
        (err) => {
          this.showWarimg = true;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wramings {
  margin-top: 10px;
  display: flex;
  & > div:nth-child(1) {
    font-size: 22px;
    color: red;
    margin-right: 10px;
  }
  & > div:nth-child(2) {
    font-size: 14px;
    color: red;
    line-height: 22px;
  }
}
.messages {
  margin-top: 20px;
  p {
    font-weight: 800;
    line-height: 22px;
  }
  margin-bottom: 40px;

}
.hiddens {
  visibility: hidden;
}
.login-info{
  margin-top:100px;
}
.agree{
    color:#F26161!important;
    cursor: pointer;
  }
.agree-box .el-checkbox__input.is-checked+.el-checkbox__label{
  color:#666666;
}
.agree-box {
  display: flex;
  line-height: 1.35em;
  margin-top: 4px;
  .check-box{
    margin-right:8px;
  }
  .agree-info{
    line-height: 1.35em;
  }
}
/deep/ .el-input__inner:focus {
  border-color: red !important;
}
.app-form-box{
	.agree-info{
		font-size: 1.4rem;
	}
	.wramings{
		height: 4rem;
		div{
			font-size: 1.4rem;
			line-height: 1.25;
		}
	}
	.btn-margin{
		margin-top:1.5rem;
	}
	.agree-box{
		margin-top: .4em;
	}
}
</style>
